import { Star } from "lucide-react";
import { useTranslate } from "ra-core";

import { cn } from "@/lib/utils";

import type { Negocio } from "../dominio/tipos";
import { formatoFecha } from "./formato";

/**
 * Marca «Interesado, falta confirmar fecha» (Jan y Robert, 13/10/2026; migración 28c): la pone
 * ese resultado y la quitan cualquier otro resultado o cualquier cambio de etapa.
 */
export const MarcaInteresado = ({
  negocio,
  className,
  soloIcono = false,
}: {
  negocio: Pick<Negocio, "interesado_at">;
  className?: string;
  /** Solo la estrella (tarjeta del Pipeline, Robert 30/10/2026); el texto, al pasar el ratón. */
  soloIcono?: boolean;
}) => {
  const translate = useTranslate();
  if (!negocio.interesado_at) return null;
  const ayuda = translate("nevora.interesado.ayuda", {
    fecha: formatoFecha(negocio.interesado_at),
  });
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full border border-amber-500/60 bg-amber-50 py-0.5 text-[11px] font-medium text-amber-900 dark:bg-amber-950/40 dark:text-amber-200",
        soloIcono ? "px-1.5" : "px-2",
        className,
      )}
      title={ayuda}
      aria-label={ayuda}
      data-testid="marca-interesado"
    >
      <Star className="size-3" aria-hidden />
      {soloIcono ? null : translate("nevora.interesado.marca")}
    </span>
  );
};
